<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

import { COMPONENT_API } from "@/config/social-api";

const MAX_IMAGE_UPLOAD_BYTES = 2 * 1024 * 1024;
/** 发往微信素材接口前控制体积，避免 45002 / content size out of limit */
const WX_MEDIA_TARGET_BYTES = Math.floor(1.65 * 1024 * 1024);

/** 头像裁剪：预览方框边长、导出正方形边长（再经 shrink 控制体积） */
const HEAD_CROP_VIEWPORT_PX = 320;
const HEAD_CROP_EXPORT_PX = 800;

export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "基础信息",
            items: [],
            loading: false,
            userinfo: {},
            appid: "",
            basic: null,
            loadError: "",
            editNickname: "",
            editSignature: "",
            nameCheckPassed: false,
            nameCheckLastNick: "",
            nameCheckHitCondition: false,
            nicknameIdCardMediaId: "",
            nicknameLicenseMediaId: "",
            uploadingimg: {
                nickname_idcard: "",
                nickname_license: "",
            },
            uploadingNicknameIdCard: false,
            uploadingNicknameLicense: false,
            namingOtherStuffMediaId: ["", "", "", "", ""],
            namingOtherStuffPreview: ["", "", "", "", ""],
            namingOtherStuffUploading: [false, false, false, false, false],
            nicknameFlowWording: "",
            checkingName: false,
            savingName: false,
            savingIntro: false,
            uploadingHead: false,
            headCropVisible: false,
            headCropObjectUrl: "",
            headCropNaturalW: 0,
            headCropNaturalH: 0,
            headCropBaseScale: 1,
            headCropZoom: 1,
            headCropTx: 0,
            headCropTy: 0,
            headCropDragging: false,
            headCropDragLast: { x: 0, y: 0 },
            headCropViewportPx: HEAD_CROP_VIEWPORT_PX,
            headCropExportPx: HEAD_CROP_EXPORT_PX,
            /** 微信搜索状态：0 可搜索，1 不可搜索 */
            editSearchStatus: 0,
            searchStatusLoaded: false,
            loadingSearchStatus: false,
            savingSearchStatus: false,
        };
    },
    mounted() {
        try {
            this.userinfo = JSON.parse(localStorage.getItem("user") || "null") || {};
        } catch (e) {
            this.userinfo = {};
        }
        this.appid = this.$route.params.appid;
        this.title = "基础信息";
        this.items = [
            { text: this.$t("menuitems.micoapp.text"), href: "/" },
            { text: this.$t("menuitems.icp.micoapp.list"), href: "/micoapp" },
            { text: this.$t("menuitems.icp.micoapp.info"), href: `/micoapp/${this.appid}` },
            {
                text: "小程序管理",
                href: `/micoapp/${this.appid}#micoapp-wechat-mgmt`,
            },
            { text: "基础信息", active: true },
        ];
        this.fetchBasicInfo();
    },
    beforeDestroy() {
        this.headCropMouseUp();
        this.revokeHeadCropUrl();
    },
    computed: {
        headCropImgStyle() {
            const vw = this.headCropViewportPx;
            const vh = this.headCropViewportPx;
            const iw = this.headCropNaturalW;
            const ih = this.headCropNaturalH;
            if (!iw || !ih) {
                return { display: "none" };
            }
            const s = this.headCropBaseScale * this.headCropZoom;
            const w = iw * s;
            const h = ih * s;
            const left = (vw - w) / 2 + this.headCropTx;
            const top = (vh - h) / 2 + this.headCropTy;
            return {
                position: "absolute",
                width: `${w}px`,
                height: `${h}px`,
                left: `${left}px`,
                top: `${top}px`,
                userSelect: "none",
                cursor: this.headCropDragging ? "grabbing" : "grab",
            };
        },
        canSubmitNickname() {
            const n = (this.editNickname || "").trim();
            return (
                this.nameCheckPassed &&
                !!n &&
                n === this.nameCheckLastNick
            );
        },
        isPrincipalPersonal() {
            return this.basic && Number(this.basic.principal_type) === 0;
        },
        isPrincipalEnterprise() {
            return this.basic && Number(this.basic.principal_type) === 1;
        },
        showNicknameSupplementSection() {
            return this.nameCheckHitCondition;
        },
    },
    watch: {
        editNickname() {
            this.resetNicknameGate();
        },
        "$route.params.appid"(id) {
            if (id && id !== this.appid) {
                this.appid = id;
                this.fetchBasicInfo();
            }
        },
    },
    methods: {
        dash(v) {
            if (v === null || v === undefined || v === "") return "—";
            return v;
        },
        boolZh(v) {
            return v ? "是" : "否";
        },
        accountTypeLabel(v) {
            const m = { 1: "订阅号", 2: "服务号", 3: "小程序" };
            return m[Number(v)] != null ? m[Number(v)] : this.dash(v);
        },
        principalTypeLabel(v) {
            const m = { 0: "个人", 1: "企业", 2: "媒体", 3: "政府", 4: "其他组织" };
            return m[Number(v)] != null ? m[Number(v)] : this.dash(v);
        },
        realnameStatusLabel(v) {
            const m = { 1: "实名验证成功", 2: "实名验证中", 3: "实名验证失败" };
            return m[Number(v)] != null ? m[Number(v)] : this.dash(v);
        },
        customerTypeLabel(v) {
            const m = {
                0: "未完成微信认证",
                1: "企业",
                2: "企业媒体",
                3: "政府",
                4: "非盈利组织",
                5: "民营非企业",
                6: "盈利组织",
                8: "社会团体",
                9: "事业媒体",
                11: "事业单位",
                12: "个体工商户",
                14: "海外企业",
                15: "个人",
            };
            return m[Number(v)] != null ? m[Number(v)] : this.dash(v);
        },
        countryLabel(v) {
            const n = Number(v);
            if (n === 1017) return "中国";
            if (Number.isNaN(n)) return "—";
            return String(v);
        },
        formatTs(val) {
            if (val === null || val === undefined || val === "" || val == 0) return "—";
            const num = Number(val);
            if (Number.isNaN(num)) return "—";
            const ms = num < 10000000000 ? num * 1000 : num;
            const d = new Date(ms);
            if (Number.isNaN(d.getTime())) return "—";
            const p = (x) => String(x).padStart(2, "0");
            return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
        },
        async fetchBasicInfo() {
            if (!this.appid) return;
            this.loading = true;
            this.loadError = "";
            this.basic = null;
            try {
                const res = await this.$axios.post(
                    COMPONENT_API,
                    { action: "getaccountbasicinfo", appid: this.appid },
                    { headers: { Openid: this.userinfo.openid } }
                );
                const data = res.data;
                if (data && Number(data.errcode) === 0) {
                    this.basic = data;
                    this.syncEditFromBasic();
                    this.fetchSearchStatus();
                } else {
                    this.loadError =
                        (data && data.errmsg) || "获取基础信息失败";
                    this.basic = data || null;
                    this.searchStatusLoaded = false;
                }
            } catch (e) {
                console.error(e);
                this.loadError = "网络请求失败";
                this.searchStatusLoaded = false;
            } finally {
                this.loading = false;
            }
        },
        goDetail() {
            this.$router.push({ path: `/micoapp/${this.appid}` });
        },
        syncEditFromBasic() {
            if (!this.basic || Number(this.basic.errcode) !== 0) return;
            this.editNickname = this.basic.nickname || "";
            const sig =
                this.basic.signature_info && this.basic.signature_info.signature;
            this.editSignature = sig != null ? String(sig) : "";
        },
        clearNicknameUploadFields() {
            this.nicknameIdCardMediaId = "";
            this.nicknameLicenseMediaId = "";
            this.uploadingimg.nickname_idcard = "";
            this.uploadingimg.nickname_license = "";
            this.namingOtherStuffMediaId = ["", "", "", "", ""];
            this.namingOtherStuffPreview = ["", "", "", "", ""];
        },
        resetNicknameGate() {
            this.nameCheckPassed = false;
            this.nameCheckLastNick = "";
            this.nameCheckHitCondition = false;
            this.clearNicknameUploadFields();
        },
        parseHitCondition(data) {
            if (!data) return false;
            const v = data.hit_condition;
            return v === true || v === 1 || v === "1";
        },
        wxOk(res) {
            const d = res && res.data;
            return d && Number(d.errcode) === 0;
        },
        wxErrmsg(res) {
            const d = res && res.data;
            return (d && d.errmsg) || "操作失败";
        },
        pickApiWording(d) {
            if (!d || d.wording == null) return "";
            const s = String(d.wording).trim();
            return s;
        },
        async postCmp(payload) {
            return this.$axios.post(COMPONENT_API, payload, {
                headers: { Openid: this.userinfo.openid },
            });
        },
        async fetchSearchStatus() {
            if (!this.appid) return;
            this.loadingSearchStatus = true;
            try {
                const res = await this.postCmp({
                    action: "getwxasearchstatus",
                    appid: this.appid,
                });
                const d = res.data || {};
                const st = Number(d.status);
                if (Number(d.errcode) === 0 && (st === 0 || st === 1)) {
                    this.editSearchStatus = st;
                    this.searchStatusLoaded = true;
                } else {
                    this.searchStatusLoaded = false;
                    this.$message.error(this.wxErrmsg(res));
                }
            } catch (e) {
                console.error(e);
                this.searchStatusLoaded = false;
                this.$message.error("获取搜索状态失败");
            } finally {
                this.loadingSearchStatus = false;
            }
        },
        async saveSearchStatus() {
            if (!this.searchStatusLoaded) {
                this.$message.warning("请先成功获取当前搜索状态");
                return;
            }
            this.savingSearchStatus = true;
            try {
                const res = await this.postCmp({
                    action: "setwxasearchstatus",
                    appid: this.appid,
                    status: this.editSearchStatus,
                });
                if (this.wxOk(res)) {
                    this.$message.success("搜索状态已保存");
                    await this.fetchSearchStatus();
                } else {
                    this.$message.error(this.wxErrmsg(res));
                }
            } catch (e) {
                console.error(e);
                this.$message.error("保存失败");
            } finally {
                this.savingSearchStatus = false;
            }
        },
        async checkNickname() {
            const name = (this.editNickname || "").trim();
            if (!name) {
                this.$message.warning("请填写要检测的名称");
                return;
            }
            this.nicknameFlowWording = "";
            this.checkingName = true;
            try {
                const res = await this.postCmp({
                    action: "checkmicoappname",
                    appid: this.appid,
                    nick_name: name,
                });
                const d = res.data;
                if (d && Number(d.errcode) === 0) {
                    this.nameCheckPassed = true;
                    this.nameCheckLastNick = name;
                    this.nameCheckHitCondition = this.parseHitCondition(d);
                    this.clearNicknameUploadFields();
                    this.nicknameFlowWording = this.pickApiWording(d);
                    this.$message.success("名称检测通过，可提交改名");
                } else {
                    this.resetNicknameGate();
                    this.nicknameFlowWording = this.pickApiWording(d);
                    this.$message.error(this.wxErrmsg(res));
                }
            } catch (e) {
                console.error(e);
                this.resetNicknameGate();
                this.nicknameFlowWording = "";
                this.$message.error("请求失败");
            } finally {
                this.checkingName = false;
            }
        },
        getBase64DataUrl(file) {
            return new Promise(function (resolve, reject) {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onerror = reject;
                reader.onloadend = function () {
                    resolve(reader.result);
                };
            });
        },
        validateUploadImageFile(raw) {
            if (!raw) return false;
            if (raw.size > MAX_IMAGE_UPLOAD_BYTES) {
                this.$message.warning("图片大小不能超过 2MB");
                return false;
            }
            return true;
        },
        friendlyWxaMediaErrmsg(data) {
            if (!data) return "操作失败";
            const code = Number(data.errcode);
            const msg = String(data.errmsg || "");
            if (
                code === 45002 ||
                /content\s*size\s*out\s*of\s*limit/i.test(msg)
            ) {
                return "图片体积超过微信接口限制（content size out of limit），已自动压缩后仍失败时请换更小分辨率或更低体积的 JPG。";
            }
            if (/cut size invalid|x1\s*y1\s*x2\s*y2/i.test(msg)) {
                return "修改头像需合法裁剪区域（x1/y1/x2/y2，相对坐标 0~1）。已自动将图片居中裁成正方形，请重试；若仍失败请换图。";
            }
            return msg || "操作失败";
        },
        async shrinkImageFileForWxa(file) {
            const maxBytes = WX_MEDIA_TARGET_BYTES;
            if (!file || file.size <= maxBytes) {
                return file;
            }
            const url = URL.createObjectURL(file);
            let img;
            try {
                img = await new Promise((resolve, reject) => {
                    const im = new Image();
                    im.onload = () => resolve(im);
                    im.onerror = () => reject(new Error("图片无法读取"));
                    im.src = url;
                });
            } finally {
                URL.revokeObjectURL(url);
            }
            let w = img.naturalWidth || img.width;
            let h = img.naturalHeight || img.height;
            if (!w || !h) {
                throw new Error("图片无效");
            }
            const maxEdge = 1920;
            if (w > maxEdge || h > maxEdge) {
                if (w >= h) {
                    h = Math.round((h * maxEdge) / w);
                    w = maxEdge;
                } else {
                    w = Math.round((w * maxEdge) / h);
                    h = maxEdge;
                }
            }
            const canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, w, h);
            const toJpeg = (q) =>
                new Promise((res) => {
                    canvas.toBlob((blob) => res(blob), "image/jpeg", q);
                });
            let q = 0.88;
            let blob = await toJpeg(q);
            while (blob && blob.size > maxBytes && q > 0.45) {
                q -= 0.07;
                blob = await toJpeg(q);
            }
            if (!blob) {
                throw new Error("图片压缩失败");
            }
            let ew = w;
            let eh = h;
            for (let step = 0; blob.size > maxBytes && step < 8; step++) {
                ew = Math.max(400, Math.round(ew * 0.88));
                eh = Math.max(400, Math.round(eh * 0.88));
                canvas.width = ew;
                canvas.height = eh;
                ctx.drawImage(img, 0, 0, ew, eh);
                blob = await toJpeg(0.72);
            }
            return blob;
        },
        revokeHeadCropUrl() {
            if (this.headCropObjectUrl) {
                URL.revokeObjectURL(this.headCropObjectUrl);
                this.headCropObjectUrl = "";
            }
        },
        openHeadCropDialog(rawFile) {
            this.revokeHeadCropUrl();
            this.headCropNaturalW = 0;
            this.headCropNaturalH = 0;
            this.headCropBaseScale = 1;
            this.headCropZoom = 1;
            this.headCropTx = 0;
            this.headCropTy = 0;
            this.headCropObjectUrl = URL.createObjectURL(rawFile);
            this.headCropVisible = true;
        },
        onHeadCropImgLoad() {
            const img = this.$refs.headCropImg;
            if (!img) return;
            const iw = img.naturalWidth || img.width;
            const ih = img.naturalHeight || img.height;
            const vw = this.headCropViewportPx;
            const vh = this.headCropViewportPx;
            if (!iw || !ih) return;
            this.headCropNaturalW = iw;
            this.headCropNaturalH = ih;
            this.headCropBaseScale = Math.max(vw / iw, vh / ih);
            this.headCropZoom = 1;
            this.headCropTx = 0;
            this.headCropTy = 0;
            this.clampHeadCropPan();
        },
        clampHeadCropPan() {
            const vw = this.headCropViewportPx;
            const vh = this.headCropViewportPx;
            const iw = this.headCropNaturalW;
            const ih = this.headCropNaturalH;
            if (!iw || !ih) return;
            const s = this.headCropBaseScale * this.headCropZoom;
            const w = iw * s;
            const h = ih * s;
            if (w >= vw) {
                const maxTx = (w - vw) / 2;
                const minTx = -(w - vw) / 2;
                this.headCropTx = Math.min(maxTx, Math.max(minTx, this.headCropTx));
            } else {
                this.headCropTx = 0;
            }
            if (h >= vh) {
                const maxTy = (h - vh) / 2;
                const minTy = -(h - vh) / 2;
                this.headCropTy = Math.min(maxTy, Math.max(minTy, this.headCropTy));
            } else {
                this.headCropTy = 0;
            }
        },
        headCropOnWheel(e) {
            if (!this.headCropVisible) return;
            e.preventDefault();
            const step = e.deltaY > 0 ? -0.08 : 0.08;
            this.headCropZoom = Math.min(4, Math.max(1, this.headCropZoom + step));
            this.clampHeadCropPan();
        },
        headCropMouseDown(e) {
            if (e.button !== 0) return;
            this.headCropDragging = true;
            this.headCropDragLast = { x: e.clientX, y: e.clientY };
            this._headCropOnMove = (ev) => {
                if (!this.headCropDragging) return;
                this.headCropTx += ev.clientX - this.headCropDragLast.x;
                this.headCropTy += ev.clientY - this.headCropDragLast.y;
                this.headCropDragLast = {
                    x: ev.clientX,
                    y: ev.clientY,
                };
                this.clampHeadCropPan();
            };
            this._headCropOnUp = () => this.headCropMouseUp();
            window.addEventListener("mousemove", this._headCropOnMove);
            window.addEventListener("mouseup", this._headCropOnUp);
        },
        headCropMouseUp() {
            this.headCropDragging = false;
            if (this._headCropOnMove) {
                window.removeEventListener("mousemove", this._headCropOnMove);
                window.removeEventListener("mouseup", this._headCropOnUp);
                this._headCropOnMove = null;
                this._headCropOnUp = null;
            }
        },
        cancelHeadCrop() {
            this.headCropVisible = false;
        },
        onHeadCropDialogClosed() {
            this.headCropMouseUp();
            this.revokeHeadCropUrl();
            this.headCropNaturalW = 0;
            this.headCropNaturalH = 0;
        },
        async confirmHeadCrop() {
            const img = this.$refs.headCropImg;
            if (!img || !this.headCropNaturalW) {
                this.$message.warning("请等待图片加载完成");
                return;
            }
            this.uploadingHead = true;
            try {
                const vw = this.headCropViewportPx;
                const vh = this.headCropViewportPx;
                const iw = this.headCropNaturalW;
                const ih = this.headCropNaturalH;
                const s = this.headCropBaseScale * this.headCropZoom;
                const w = iw * s;
                const h = ih * s;
                const left = (vw - w) / 2 + this.headCropTx;
                const top = (vh - h) / 2 + this.headCropTy;
                let sx = (-left) / s;
                let sy = (-top) / s;
                let sw = vw / s;
                let sh = vh / s;
                sx = Math.max(0, Math.min(iw - sw, sx));
                sy = Math.max(0, Math.min(ih - sh, sy));
                sw = Math.min(sw, iw - sx);
                sh = Math.min(sh, ih - sy);
                const canvas = document.createElement("canvas");
                canvas.width = vw;
                canvas.height = vh;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, sx, sy, sw, sh, 0, 0, vw, vh);
                const exp = this.headCropExportPx;
                const out = document.createElement("canvas");
                out.width = exp;
                out.height = exp;
                out.getContext("2d").drawImage(canvas, 0, 0, vw, vh, 0, 0, exp, exp);
                const blob = await new Promise((resolve, reject) => {
                    out.toBlob(
                        (b) =>
                            b ? resolve(b) : reject(new Error("导出失败")),
                        "image/jpeg",
                        0.92
                    );
                });
                const shrunk = await this.shrinkImageFileForWxa(blob);
                const ok = await this.uploadHeadPreparedBlob(shrunk);
                if (ok) {
                    this.headCropVisible = false;
                    this.revokeHeadCropUrl();
                    this.headCropNaturalW = 0;
                    this.headCropNaturalH = 0;
                }
            } catch (e) {
                console.error(e);
                this.$message.error(
                    (e && e.message) || "头像处理失败"
                );
            } finally {
                this.uploadingHead = false;
            }
        },
        async uploadHeadPreparedBlob(blob) {
            const uri = await this.readFileAsBase64Body(blob);
            const mediaId = await this.uploadMediaImage(uri, "basicinfo_head");
            const res = await this.postCmp({
                action: "setmicoapphead",
                appid: this.appid,
                media_id: mediaId,
            });
            if (this.wxOk(res)) {
                this.$message.success("头像已提交修改");
                this.fetchBasicInfo();
                return true;
            }
            this.$message.error(this.friendlyWxaMediaErrmsg(res.data));
            return false;
        },
        /** 临时图片素材：componentapi upload_media_image → Component::upload_media_image */
        uploadMediaImage(base64Body, field) {
            const that = this;
            return that.$axios
                .post(
                    COMPONENT_API,
                    {
                        action: "upload_media_image",
                        appid: that.appid,
                        uri: base64Body,
                        field,
                    },
                    { headers: { Openid: that.userinfo.openid } }
                )
                .then(function (response) {
                    const d = response.data || {};
                    const mid = d.media_id;
                    if (mid) {
                        return mid;
                    }
                    return Promise.reject(
                        new Error(that.friendlyWxaMediaErrmsg(d))
                    );
                });
        },
        nicknameIdCardUpload(file) {
            if (this.uploadingNicknameIdCard || !file.raw) return;
            if (!this.validateUploadImageFile(file.raw)) return;
            this.uploadingNicknameIdCard = true;
            this.shrinkImageFileForWxa(file.raw)
                .then((blob) => this.getBase64DataUrl(blob))
                .then((res) => {
                    const params = String(res).split(",");
                    if (params.length > 1) {
                        this.uploadingimg.nickname_idcard =
                            params[0] + "," + params[1];
                        return this.uploadMediaImage(
                            params[1],
                            "basicinfo_nick_idcard"
                        ).then((mediaId) => {
                            this.nicknameIdCardMediaId = mediaId;
                            this.$message.success("身份证材料已上传");
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(
                        (err && err.message) || "上传失败，请重试"
                    );
                })
                .finally(() => {
                    this.uploadingNicknameIdCard = false;
                });
        },
        nicknameLicenseUpload(file) {
            if (this.uploadingNicknameLicense || !file.raw) return;
            if (!this.validateUploadImageFile(file.raw)) return;
            this.uploadingNicknameLicense = true;
            this.shrinkImageFileForWxa(file.raw)
                .then((blob) => this.getBase64DataUrl(blob))
                .then((res) => {
                    const params = String(res).split(",");
                    if (params.length > 1) {
                        this.uploadingimg.nickname_license =
                            params[0] + "," + params[1];
                        return this.uploadMediaImage(
                            params[1],
                            "basicinfo_nick_license"
                        ).then((mediaId) => {
                            this.nicknameLicenseMediaId = mediaId;
                            this.$message.success("营业执照已上传");
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(
                        (err && err.message) || "上传失败，请重试"
                    );
                })
                .finally(() => {
                    this.uploadingNicknameLicense = false;
                });
        },
        namingOtherStuffUpload(file, index) {
            const idx = Number(index);
            if (
                idx < 0 ||
                idx > 4 ||
                this.namingOtherStuffUploading[idx] ||
                !file.raw
            ) {
                return;
            }
            if (!this.validateUploadImageFile(file.raw)) return;
            this.$set(this.namingOtherStuffUploading, idx, true);
            this.shrinkImageFileForWxa(file.raw)
                .then((blob) => this.getBase64DataUrl(blob))
                .then((res) => {
                    const params = String(res).split(",");
                    if (params.length > 1) {
                        this.$set(
                            this.namingOtherStuffPreview,
                            idx,
                            params[0] + "," + params[1]
                        );
                        const field = `basicinfo_nick_other_${idx + 1}`;
                        return this.uploadMediaImage(
                            params[1],
                            field
                        ).then((mediaId) => {
                            this.$set(this.namingOtherStuffMediaId, idx, mediaId);
                            this.$message.success(`补充图 ${idx + 1} 已上传`);
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error(
                        (err && err.message) || "上传失败，请重试"
                    );
                })
                .finally(() => {
                    this.$set(this.namingOtherStuffUploading, idx, false);
                });
        },
        async submitNickname() {
            const name = (this.editNickname || "").trim();
            if (!name) {
                this.$message.warning("请填写新的小程序名称");
                return;
            }
            if (!this.canSubmitNickname) {
                this.$message.warning("请先完成名称检测后再提交");
                return;
            }
            this.nicknameFlowWording = "";
            this.savingName = true;
            try {
                const body = {
                    action: "setmicoappname",
                    appid: this.appid,
                    nick_name: name,
                };
                const idc = (this.nicknameIdCardMediaId || "").trim();
                const lic = (this.nicknameLicenseMediaId || "").trim();
                if (this.isPrincipalPersonal && idc) body.id_card = idc;
                if (this.isPrincipalEnterprise && lic) body.license = lic;
                for (let i = 0; i < 5; i++) {
                    const m = (this.namingOtherStuffMediaId[i] || "").trim();
                    if (m) {
                        body[`naming_other_stuff_${i + 1}`] = m;
                    }
                }
                const res = await this.postCmp(body);
                const d = res.data;
                if (d && Number(d.errcode) === 0) {
                    const extra =
                        d.audit_id != null
                            ? `，审核单号：${d.audit_id}`
                            : "";
                    this.nicknameFlowWording = this.pickApiWording(d);
                    this.$message.success(`已提交${extra}`);
                    this.resetNicknameGate();
                    this.fetchBasicInfo();
                } else {
                    this.nicknameFlowWording = this.pickApiWording(d);
                    this.$message.error(this.wxErrmsg(res));
                }
            } catch (e) {
                console.error(e);
                this.nicknameFlowWording = "";
                this.$message.error("请求失败");
            } finally {
                this.savingName = false;
            }
        },
        async saveIntroduction() {
            const text = (this.editSignature || "").trim();
            if (!text) {
                this.$message.warning("请填写功能介绍");
                return;
            }
            this.savingIntro = true;
            try {
                const res = await this.postCmp({
                    action: "setmicoappintroduction",
                    appid: this.appid,
                    signature: text,
                });
                if (this.wxOk(res)) {
                    this.$message.success("功能介绍已更新");
                    this.fetchBasicInfo();
                } else {
                    this.$message.error(this.wxErrmsg(res));
                }
            } catch (e) {
                console.error(e);
                this.$message.error("请求失败");
            } finally {
                this.savingIntro = false;
            }
        },
        readFileAsBase64Body(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    const s = reader.result;
                    if (typeof s !== "string") {
                        reject(new Error("read fail"));
                        return;
                    }
                    const i = s.indexOf(",");
                    resolve(i >= 0 ? s.slice(i + 1) : s);
                };
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        },
        onHeadFileSelected(file) {
            const raw = file && file.raw;
            if (!raw || this.uploadingHead) return;
            if (!this.validateUploadImageFile(raw)) return;
            this.openHeadCropDialog(raw);
        },
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="micoapp-page micoapp-basicinfo-page" v-loading="loading">
            <div class="row">
                <div class="col-12">
                    <div class="card micoapp-info-card">
                        <div class="card-body">
                            <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                                <h6 class="micoapp-info-card-title mb-0">
                                    账号基础信息
                                </h6>
                                <div>
                                    <el-button size="small" @click="goDetail">返回小程序详情</el-button>
                                    <el-button type="primary" size="small" :loading="loading" @click="fetchBasicInfo">
                                        刷新
                                    </el-button>
                                </div>
                            </div>
                            <el-alert v-if="loadError" type="error" :title="loadError" :closable="false" show-icon class="mb-3" />
                            <template v-if="basic && Number(basic.errcode) === 0">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <h6 class="micoapp-info-card-title">账号概要</h6>
                                        <dl class="micoapp-info-dl">
                                            <dt>AppID</dt>
                                            <dd>{{ dash(basic.appid) }}</dd>
                                            <dt>账号类型</dt>
                                            <dd>{{ accountTypeLabel(basic.account_type) }}</dd>
                                            <dt>小程序名称</dt>
                                            <dd>{{ dash(basic.nickname) }}</dd>
                                            <dt>注册国家/地区</dt>
                                            <dd>{{ countryLabel(basic.registered_country) }}</dd>
                                        </dl>
                                        <dl v-if="basic.head_image_info && basic.head_image_info.head_image_url" class="micoapp-info-dl mt-2">
                                            <dt>头像</dt>
                                            <dd class="mb-0">
                                                <img
                                                    :src="basic.head_image_info.head_image_url"
                                                    alt="头像"
                                                    class="micoapp-basicinfo-head"
                                                    referrerpolicy="no-referrer"
                                                />
                                            </dd>
                                        </dl>
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <h6 class="micoapp-info-card-title">主体与实名</h6>
                                        <dl class="micoapp-info-dl">
                                            <dt>主体类型</dt>
                                            <dd>{{ principalTypeLabel(basic.principal_type) }}</dd>
                                            <dt>主体名称</dt>
                                            <dd>{{ dash(basic.principal_name) }}</dd>
                                            <dt>证件代码/代号</dt>
                                            <dd>{{ dash(basic.credential) }}</dd>
                                            <dt>实名验证状态</dt>
                                            <dd>{{ realnameStatusLabel(basic.realname_status) }}</dd>
                                            <dt>认证类型</dt>
                                            <dd>{{ customerTypeLabel(basic.customer_type) }}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-md-6 mb-3" v-if="basic.wx_verify_info">
                                        <h6 class="micoapp-info-card-title">微信认证信息</h6>
                                        <dl class="micoapp-info-dl">
                                            <dt>资质认证</dt>
                                            <dd>{{ boolZh(basic.wx_verify_info.qualification_verify) }}</dd>
                                            <dt>名称认证</dt>
                                            <dd>{{ boolZh(basic.wx_verify_info.naming_verify) }}</dd>
                                            <dt v-if="basic.wx_verify_info.qualification_verify">是否需要年审</dt>
                                            <dd v-if="basic.wx_verify_info.qualification_verify">{{ boolZh(basic.wx_verify_info.annual_review) }}</dd>
                                            <dt v-if="basic.wx_verify_info.annual_review_begin_time">年审开始时间</dt>
                                            <dd v-if="basic.wx_verify_info.annual_review_begin_time">{{ formatTs(basic.wx_verify_info.annual_review_begin_time) }}</dd>
                                            <dt v-if="basic.wx_verify_info.annual_review_end_time">年审截止时间</dt>
                                            <dd v-if="basic.wx_verify_info.annual_review_end_time">{{ formatTs(basic.wx_verify_info.annual_review_end_time) }}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-md-6 mb-3" v-if="basic.signature_info">
                                        <h6 class="micoapp-info-card-title">功能介绍</h6>
                                        <dl class="micoapp-info-dl">
                                            <dt>介绍文案</dt>
                                            <dd>{{ dash(basic.signature_info.signature) }}</dd>
                                            <dt>本月已修改次数</dt>
                                            <dd>{{ dash(basic.signature_info.modify_used_count) }}</dd>
                                            <dt>本月修改额度</dt>
                                            <dd>{{ dash(basic.signature_info.modify_quota) }}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-md-6 mb-3" v-if="basic.head_image_info">
                                        <h6 class="micoapp-info-card-title">头像修改额度</h6>
                                        <dl class="micoapp-info-dl">
                                            <dt>本年已修改次数</dt>
                                            <dd>{{ dash(basic.head_image_info.modify_used_count) }}</dd>
                                            <dt>本年修改额度</dt>
                                            <dd>{{ dash(basic.head_image_info.modify_quota) }}</dd>
                                        </dl>
                                    </div>
                                    <div class="col-md-6 mb-3" v-if="basic.nickname_info">
                                        <h6 class="micoapp-info-card-title">名称信息</h6>
                                        <dl class="micoapp-info-dl">
                                            <dt>名称</dt>
                                            <dd>{{ dash(basic.nickname_info.nickname) }}</dd>
                                            <dt>本年已修改次数</dt>
                                            <dd>{{ dash(basic.nickname_info.modify_used_count) }}</dd>
                                            <dt>本年修改额度</dt>
                                            <dd>{{ dash(basic.nickname_info.modify_quota) }}</dd>
                                        </dl>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="basic && Number(basic.errcode) === 0">
                    <div class="card micoapp-info-card">
                        <div class="card-body">
                            <h6 class="micoapp-info-card-title">修改基础信息</h6>
                            <el-form label-width="130px" class="micoapp-basicinfo-edit-form">
                                <el-form-item label="小程序名称">
                                    <div class="d-flex flex-wrap align-items-center gap-2" style="gap: 8px;">
                                        <el-input
                                            v-model="editNickname"
                                            placeholder="新名称"
                                            maxlength="30"
                                            show-word-limit
                                            clearable
                                            style="max-width: 320px;"
                                        />
                                        <el-button
                                            size="small"
                                            :loading="checkingName"
                                            @click="checkNickname"
                                        >
                                            检测名称
                                        </el-button>
                                        <el-button
                                            type="primary"
                                            size="small"
                                            :loading="savingName"
                                            :disabled="!canSubmitNickname"
                                            @click="submitNickname"
                                        >
                                            提交改名
                                        </el-button>
                                    </div>
                                    <p
                                        v-if="nicknameFlowWording"
                                        class="small mb-0 mt-2 micoapp-nickname-api-wording"
                                    >
                                        {{ nicknameFlowWording }}
                                    </p>
                                </el-form-item>
                                <el-form-item
                                    v-if="showNicknameSupplementSection"
                                    label="名称补充材料"
                                >
                                    <p class="text-muted small mb-3">单张图片不超过 2MB。</p>
                                    <div class="d-flex flex-wrap gap-3 mb-3">
                                        <div v-if="isPrincipalPersonal">
                                            <div class="text-muted small mb-1">身份证（个人主体）</div>
                                            <el-upload
                                                class="micoapp-basicinfo-nick-uploader avatar-uploader"
                                                action="#"
                                                accept=".jpg,.jpeg"
                                                :show-file-list="false"
                                                :auto-upload="false"
                                                :on-change="nicknameIdCardUpload"
                                            >
                                                <img
                                                    v-if="uploadingimg.nickname_idcard"
                                                    :src="uploadingimg.nickname_idcard"
                                                    class="avatar"
                                                    alt=""
                                                />
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                        </div>
                                        <div v-if="isPrincipalEnterprise">
                                            <div class="text-muted small mb-1">营业执照（企业主体）</div>
                                            <el-upload
                                                class="micoapp-basicinfo-nick-uploader avatar-uploader"
                                                action="#"
                                                accept=".jpg,.jpeg"
                                                :show-file-list="false"
                                                :auto-upload="false"
                                                :on-change="nicknameLicenseUpload"
                                            >
                                                <img
                                                    v-if="uploadingimg.nickname_license"
                                                    :src="uploadingimg.nickname_license"
                                                    class="avatar"
                                                    alt=""
                                                />
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                        </div>
                                    </div>
                                    <div class="text-muted small mb-2">其它材料</div>
                                    <div class="d-flex flex-wrap micoapp-basicinfo-nick-other-row">
                                        <div
                                            v-for="n in 5"
                                            :key="'nostuff-' + n"
                                            class="micoapp-basicinfo-nick-other-cell"
                                        >
                                            <div class="text-muted small mb-1">图 {{ n }}</div>
                                            <el-upload
                                                class="micoapp-basicinfo-nick-other-uploader avatar-uploader"
                                                action="#"
                                                accept=".jpg,.jpeg"
                                                :show-file-list="false"
                                                :auto-upload="false"
                                                :on-change="(f) => namingOtherStuffUpload(f, n - 1)"
                                            >
                                                <img
                                                    v-if="namingOtherStuffPreview[n - 1]"
                                                    :src="namingOtherStuffPreview[n - 1]"
                                                    class="avatar"
                                                    alt=""
                                                />
                                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                            </el-upload>
                                        </div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="功能介绍">
                                    <el-input
                                        v-model="editSignature"
                                        type="textarea"
                                        :rows="3"
                                        maxlength="120"
                                        show-word-limit
                                        placeholder="小程序功能介绍"
                                        style="max-width: 560px;"
                                    />
                                    <div class="mt-2">
                                        <el-button
                                            type="primary"
                                            size="small"
                                            :loading="savingIntro"
                                            @click="saveIntroduction"
                                        >
                                            保存介绍
                                        </el-button>
                                    </div>
                                </el-form-item>
                                <el-form-item label="修改头像">
                                    <el-upload
                                        class="micoapp-basicinfo-head-upload"
                                        action="#"
                                        accept=".jpg,.jpeg"
                                        :show-file-list="false"
                                        :auto-upload="false"
                                        :on-change="onHeadFileSelected"
                                    >
                                        <el-button size="small" :loading="uploadingHead">选择 JPG 并裁剪上传</el-button>
                                    </el-upload>
                                    <span class="text-muted small d-block mt-1">单张不超过 2MB；在弹窗内拖拽平移、滚轮缩放，框内为方形裁切区域；需符合微信头像规范。</span>
                                </el-form-item>
                                <div class="mt-4 pt-3 border-top">
                                    <h6 class="micoapp-info-card-title mb-3">
                                        其它设置
                                    </h6>
                                    <el-form-item label="搜索状态">
                                        <div
                                            class="d-flex flex-wrap align-items-center gap-2"
                                            style="gap: 8px;"
                                        >
                                            <el-radio-group
                                                v-model="editSearchStatus"
                                                :disabled="
                                                    !searchStatusLoaded ||
                                                    loadingSearchStatus
                                                "
                                            >
                                                <el-radio :label="0">
                                                    可被搜索
                                                </el-radio>
                                                <el-radio :label="1">
                                                    不可被搜索
                                                </el-radio>
                                            </el-radio-group>
                                            <el-button
                                                size="small"
                                                :loading="loadingSearchStatus"
                                                @click="fetchSearchStatus"
                                            >
                                                刷新状态
                                            </el-button>
                                            <el-button
                                                type="primary"
                                                size="small"
                                                :loading="savingSearchStatus"
                                                :disabled="!searchStatusLoaded"
                                                @click="saveSearchStatus"
                                            >
                                                保存
                                            </el-button>
                                        </div>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="裁剪头像（方形）"
            :visible.sync="headCropVisible"
            width="440px"
            append-to-body
            :close-on-click-modal="false"
            @closed="onHeadCropDialogClosed"
        >
            <p class="text-muted small mb-2">
                拖拽图片平移，滚轮缩放；方框内区域将上传为头像。
            </p>
            <div
                class="micoapp-head-crop-viewport"
                :style="{
                    width: headCropViewportPx + 'px',
                    height: headCropViewportPx + 'px',
                }"
                @wheel="headCropOnWheel"
            >
                <img
                    v-show="headCropObjectUrl"
                    ref="headCropImg"
                    :src="headCropObjectUrl"
                    alt=""
                    class="micoapp-head-crop-img"
                    draggable="false"
                    :style="headCropImgStyle"
                    @load="onHeadCropImgLoad"
                    @mousedown.prevent="headCropMouseDown"
                />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelHeadCrop">取消</el-button>
                <el-button
                    type="primary"
                    :loading="uploadingHead"
                    :disabled="!headCropNaturalW"
                    @click="confirmHeadCrop"
                >
                    确定并上传
                </el-button>
            </span>
        </el-dialog>
    </Layout>
</template>

<style scoped>
.micoapp-info-card {
    margin-bottom: 1.5rem;
}

.micoapp-nickname-api-wording {
    color: #f56c6c;
}

.micoapp-head-crop-viewport {
    position: relative;
    overflow: hidden;
    margin: 0 auto;
    background: #111827;
    border-radius: 4px;
    box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.15);
}

.micoapp-head-crop-img {
    display: block;
    max-width: none;
    pointer-events: auto;
}

.micoapp-info-card-title {
    font-weight: 600;
    color: #374151;
    margin: 0 0 1rem 0;
    font-size: 1rem;
}

.micoapp-info-dl {
    margin: 0;
}

.micoapp-info-dl dt {
    font-size: 0.8rem;
    color: #6b7280;
    margin-bottom: 0.25rem;
    font-weight: 500;
}

.micoapp-info-dl dd {
    margin: 0 0 0.75rem 0;
    font-size: 0.95rem;
    color: #1f2937;
}

.micoapp-basicinfo-head {
    width: 88px;
    height: 88px;
    border-radius: 16px;
    object-fit: cover;
    border: 1px solid #e5e7eb;
    margin-top: 0.35rem;
}

::v-deep .micoapp-basicinfo-nick-uploader.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .micoapp-basicinfo-nick-uploader.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.micoapp-basicinfo-nick-uploader .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.micoapp-basicinfo-nick-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: cover;
}

.micoapp-basicinfo-nick-other-row {
    gap: 12px;
}

.micoapp-basicinfo-nick-other-cell {
    flex: 0 0 auto;
}

::v-deep .micoapp-basicinfo-nick-other-uploader.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
}

::v-deep .micoapp-basicinfo-nick-other-uploader.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.micoapp-basicinfo-nick-other-uploader .avatar-uploader-icon {
    font-size: 22px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}

.micoapp-basicinfo-nick-other-uploader .avatar {
    width: 100px;
    height: 100px;
    display: block;
    object-fit: cover;
}
</style>
